// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_ZFK","cls2":"LoggedOutDiscoveryPage-cls2_S7P LoggedOutDiscoveryPage-cls1_ZFK"};